import { useRef } from 'react'

import { GeneralOcrTableContext } from './useGeneralOcrTableRefContext'

/**
 * GeneralOcrTableRefs represents a 3-dimensional array of HTMLDivElement references.
 * - The first dimension (tableIndex): Index of the table
 * - The second dimension (rowIndex): Index of the row within the table
 * - The third dimension(columnIndex): Index of the column within the row
 */
export type ContextType = HTMLDivElement[][][]

export const GeneralOcrTableRefsProvider = ({ children }) => {
  const divRefs = useRef<ContextType>([])
  return (
    <GeneralOcrTableContext.Provider value={divRefs}>{children}</GeneralOcrTableContext.Provider>
  )
}
